import { color } from "@/styles/theme";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";

type Props = {
  fill: boolean;
  variant: "secondary" | "destructive";
  text: string;
  paddingVertical?: number;
  paddingHorizontal?: number;
  toolTip?: JSX.Element;
};
export const Badge = (props: Props) => {
  const paddingVertical = props.paddingVertical
    ? `${props.paddingVertical}px`
    : "0px";
  const paddingHorizontal = props.paddingHorizontal
    ? `${props.paddingHorizontal}px`
    : "8px";
  return (
    <div
      css={container(
        props.fill,
        props.variant,
        paddingVertical,
        paddingHorizontal
      )}
    >
      <Font variant="s">{props.text}</Font>
      {props.toolTip}
    </div>
  );
};

const container = (
  fill: boolean,
  variant: "secondary" | "destructive",
  paddingVertical: string,
  paddingHorizontal: string
) =>
  css({
    borderRadius: "12px",
    padding: `${paddingVertical} ${paddingHorizontal}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...(fill && {
      backgroundColor:
        variant === "secondary"
          ? color.gray100
          : variant === "destructive"
          ? color.attention
          : "transparent",
      color: color.black,
      borderColor:
        variant === "secondary"
          ? color.gray100
          : variant === "destructive"
          ? color.attention
          : "transparent",
    }),
    ...(!fill && {
      color:
        variant === "secondary"
          ? color.gray600
          : variant === "destructive"
          ? color.attention
          : color.black,
      borderColor:
        variant === "secondary"
          ? color.gray600
          : variant === "destructive"
          ? color.attention
          : "transparent",
    }),
    borderWidth: "1px",
    borderStyle: "solid",
    gap: "4px",
  });
